import { TranslationKeys } from "../contexts/TranslationKeys";
import { Translator } from "../contexts/translator";
import { MultiSelectOption } from "../models/MultiSelectOption";

export const getApbOptions = (translate: Translator): MultiSelectOption[] => {
    return [
        {
            label: translate.byKey(TranslationKeys.off),
            value: "0",
        },
        {
            label: translate.byKey(TranslationKeys.relaxed),
            value: "1",
        },
        {
            label: translate.byKey(TranslationKeys.strict),
            value: "2",
        },
    ];
};
